var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-page-main" },
    [
      _vm.useNewWorkpackagesPageLayout
        ? [
            _c("work-packages-new", {
              attrs: {
                heading: "home.templateHeading",
                "filtered-workpackages": _vm.masterWorkpackages,
                "sort-desc": false,
                "allow-new": false,
                "search-workpackages": false,
                "e2e-slug": "panelTemplateWPNew",
              },
            }),
            _vm._v(" "),
            _c("work-packages-new", {
              attrs: {
                heading: "home.activeHeading",
                "filtered-workpackages": [
                  ..._vm.mockedActiveWorkpackages,
                  ..._vm.activeWorkpackages,
                ],
                "sort-desc": false,
                "allow-new": true,
                "allow-copy": true,
                "e2e-slug": "panelActiveWPNew",
              },
            }),
            _vm._v(" "),
            _c("work-packages-new", {
              attrs: {
                heading: "home.archivedHeading",
                "filtered-workpackages": [
                  ..._vm.mockedArchivedWorkpackages,
                  ..._vm.archivedWorkpackages,
                ],
                "sort-desc": true,
                "allow-new": false,
                "allow-copy": true,
                expanded: false,
                "e2e-slug": "panelArchivedWPNew",
              },
              on: {
                expand: function ($event) {
                  return _vm.getInactiveWorkpackages()
                },
              },
            }),
          ]
        : [
            _c("work-packages", {
              attrs: {
                heading: "home.templateHeading",
                "filtered-workpackages": _vm.masterWorkpackages,
                "sort-desc": false,
                "allow-new": false,
                "search-workpackages": false,
                "e2e-slug": "panelTemplateWP",
              },
            }),
            _vm._v(" "),
            _c("work-packages", {
              ref: "activeWorkpackages",
              attrs: {
                heading: "home.activeHeading",
                "filtered-workpackages": [
                  ..._vm.mockedActiveWorkpackages,
                  ..._vm.activeWorkpackages,
                ],
                "sort-desc": false,
                "allow-new": true,
                "allow-copy": true,
                "e2e-slug": "panelActiveWP",
              },
            }),
            _vm._v(" "),
            _c("work-packages", {
              ref: "archivedWorkpackages",
              attrs: {
                heading: "home.archivedHeading",
                "filtered-workpackages": [
                  ..._vm.mockedArchivedWorkpackages,
                  ..._vm.archivedWorkpackages,
                ],
                "sort-desc": true,
                "allow-new": false,
                "allow-copy": true,
                expanded: false,
                "e2e-slug": "panelArchivedWP",
              },
              on: {
                expand: function ($event) {
                  return _vm.getInactiveWorkpackages()
                },
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }